<!-- TEMPLATE -->
<template>
  <div class="btn-group">
    <button
      v-on:click="selectOption('w')"
      type="button"
      :class="[isActive('w') ? 'btn-default' : 'btn-simple']"
      class="btn btn-sm"
    >
      Week
    </button>
    <button
      v-on:click="selectOption('m')"
      type="button"
      :class="[isActive('m') ? 'btn-default' : 'btn-simple']"
      class="btn btn-sm"
    >
      1 Month
    </button>
    <button
      v-on:click="selectOption('3m')"
      type="button"
      :class="[isActive('3m') ? 'btn-default' : 'btn-simple']"
      class="btn btn-sm"
    >
      3 Months
    </button>
    <button
      v-on:click="selectOption('6m')"
      type="button"
      :class="[isActive('6m') ? 'btn-default' : 'btn-simple']"
      class="btn btn-sm"
    >
      6 Months
    </button>
    <button
      v-on:click="selectOption('y')"
      type="button"
      :class="[isActive('y') ? 'btn-default' : 'btn-simple']"
      class="btn btn-sm"
    >
      Year
    </button>
  </div>
</template>

<!-- SCRIPT -->
<script>
export default {
  name: "Filters",
  data: function () {
    return {
      selectedFilter: this.$store.state.statsIntervalFilter,
    };
  },
  methods: {
    selectOption(value) {
      this.$store.commit("setStatsIntervalFilter", value);
      this.$store.dispatch("refreshPhishingWebsites");
      this.$store.dispatch("refreshGraphs");
    },
    isActive(value) {
      return value === this.$store.state.statsIntervalFilter ? true : false;
    },
  },
};
</script>

<!-- Style -->
<style>
</style> 